import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';
import { CompanySettings } from './containers/CompanySettings/index.ts';

export default {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  AccountTypes: lazy(() => import('./containers/AccountTypes/index.tsx')),
  CampaignTypes: lazy(() => import('./containers/CampaignTypes/index.tsx')),
  CampaignTypesV2: lazyNamed(() => import('./containers/CampaignTypesV2/index.tsx'), 'CampaignTypes'),
  Industries: lazyNamed(() => import('./containers/Industries/index.tsx'), 'Industries'),
  Labels: lazy(() => import('./containers/Labels/index.tsx')),

  CompanySettings,

  PassendoProgrammatic: {
    Layout: lazy(() => import('./containers/Passendo/Layout.tsx')),
    WebsitesMapping: lazy(() => import('./containers/Passendo/WebsitesMapping/index.tsx')),
  },

  Websites: {
    WebsitesList: lazyNamed(() => import('./containers/Websites/containers/WebsitesList/index.tsx'), 'WebsitesList'),
    WebsiteForm: lazyNamed(() => import('./containers/Websites/containers/WebsiteForm/index.tsx'), 'WebsiteForm'),
    WebsiteHistory: lazyNamed(() => import('./containers/Websites/containers/WebsiteHistory/index.tsx'), 'WebsiteHistory'),
  },

  SalesUnits: lazyNamed(() => import('./containers/SalesUnits/index.tsx'), 'SalesUnits'),
};
